import React, { Fragment, useEffect, useState } from "react";
import "./ScopeSelection.scss";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  Dialog,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MethodSelection from "../MethodSelection/MethodSelection";
import { STEPS, UPLOAD_TYPE } from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import { getAssetListService } from "../../../services/assetService";
import { toastMessage } from "../../../helper";
import AssetActivityData from "../AssetActivityData/AssetActivityData";
import AssetsScopeSelection from "./AssetsScopeSelection";
const ScopeSelection = (props: any) => {
  const { t, i18n } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const {
    setStep,
    categoryData,
    selectedCategory,
    setUploadType,
    setSelectedCategory,
    categoryPreferences,
    setIsBulkUpload,
    setCategoryPreferences,
    assetsList,
    setAssetsList,
    setSelectedAssetsData,
  } = props;
  const navigate = useNavigate();
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const [showAssets, setShowAssets] = useState(false);
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [methods, setMethods] = useState(false);
  const [categoryPreference, setCategoryPreference] = useState<any>({});
  useEffect(() => {
    let uploadType = state.uploadType ? state.uploadType : UPLOAD_TYPE.MANUAL;
    setUploadType(uploadType);
    setIsBulkUpload(state?.uploadType === UPLOAD_TYPE.BULKUPLOAD);
  }, []);
  const onClickSearch = () => {};
  const onScopeSelect = (category: any, scope: number) => {
    setSelectedCategory({
      ...category,
      parent: scope,
    });
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    let catPreference = categoryPreferences.find(
      (eachPref: any) => eachPref[key] === category.id
    );
    let catPrefMethods = categoryPreferences
      .find((eachPref: any) => eachPref.category === category.id)
      ?.methods?.filter((eachMethod: any) => eachMethod.selected);
    if (
      catPrefMethods?.length > 1 ||
      catPreference.emissionSources?.length > 1
    ) {
      setOpen(true);
      setMethods(catPrefMethods);
    } else {
      if (catPreference.emissionSources.length === 1) {
        catPreference.emissionType = catPreference.emissionSources[0].type;
        catPreference.emissionSubType =
          catPreference.emissionSources[0].subType;
      }
      setStep(STEPS.ACTIVITY_DATA);
    }
    setCategoryPreference(catPreference);
  };
  const handleMouseEnterProceed = (index: any) => {
    setAssetsList(
      assetsList.map((each: any, i: any) =>
        index === i
          ? { ...each, isHovered: true }
          : { ...each, isHovered: false }
      )
    );
  };
  const handleMouseLeaveProceed = (index: any) => {
    setAssetsList(
      assetsList.map((each: any, i: any) =>
        index === i ? { ...each, isHovered: false } : each
      )
    );
  };
  const onMethodSelection = (id: number) => {
    setSelectedCategory((prevState: any) => {
      return { ...prevState, method: id };
    });
    setStep(STEPS.ACTIVITY_DATA);
  };

  const containsString = (searchString: String, obj: any) => {
    searchString = searchString.toLowerCase();
    let contains = false;
    if (obj.categories) {
      obj.categories.map((subCategory: any) => {
        if (
          subCategory?.name.toLowerCase().includes(searchString) ||
          subCategory?.code.toLowerCase().includes(searchString) ||
          subCategory?.description.toLowerCase().includes(searchString)
        ) {
          contains = true;
        }
      });
    } else {
      contains =
        obj?.name.toLowerCase().includes(searchString) ||
        obj?.code.toLowerCase().includes(searchString) ||
        obj?.description.toLowerCase().includes(searchString);
    }
    return contains;
  };
  const onClickCancel = () => {
    setSearchText("");
  };
  const imgURLs = {
    "Category 1.1": "assets/icons/Category_1.1.svg",
    "Category 1.2": "assets/icons/Category_1.2.svg",
    "Category 1.3": "assets/icons/Category_1.3.svg",
    "Category 1.4": "assets/icons/Category_1.4.svg",
    "Category 1.5": "assets/icons/Category_1.5.svg",
    "Category 2.1": "assets/icons/Category_2.1.svg",
    "Category 2.2": "assets/icons/Category_2.2.svg",
    "Category 2.3": "assets/icons/Category_2.3.svg",
    "Category 3.1": "assets/icons/Category_3.1.svg",
    "Category 3.2": "assets/icons/Category_3.2.svg",
    "Category 3.3": "assets/icons/Category_3.3.svg",
    "Category 3.4": "assets/icons/Category_3.4.svg",
    "Category 3.5": "assets/icons/Category_3.5.svg",
    "Category 4.1": "assets/icons/Category_4.1.svg",
    "Category 4.2": "assets/icons/Category_4.2.svg",
    "Category 4.3": "assets/icons/Category_4.3.svg",
    "Category 4.4": "assets/icons/Category_4.4.svg",
    "Category 5.1": "assets/icons/Category_5.1.svg",
    "Category 5.2": "assets/icons/Category_5.2.svg",
    "Category 5.3": "assets/icons/Category_5.3.svg",
    "Category 5.4": "assets/icons/Category_5.4.svg",
    "Category 5.5": "assets/icons/Category_5.5.svg",
    "Category 6.1": "assets/icons/Category_6.1.svg",
  };

  useEffect(() => {
    if (state?.selectedCategory) {
      categoryData.forEach((eachCategory: any) => {
        eachCategory.categories.forEach((eachSubCategory: any) => {
          if (eachSubCategory.id === state.selectedCategory) {
            onScopeSelect(eachSubCategory, eachCategory.scope);
          }
        });
      });
    }
  }, [categoryData]);

  useEffect(() => {
    const reqObj = {
      controller: controller,
      searchText: searchText,
    };
    getAssetListService(reqObj)
      .then((res) => {
        const data = res.data;
        const assetsList = data.assets;
        setAssetsList([...assetsList]);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  }, [controller]);

  return (
    <Fragment>
      {open && (
        <Dialog
          open={open}
          onClose={() => {
            // setOpen(false);
            navigate("/log/emissions");
          }}
          maxWidth="md"
          className="pw-scope-dialog"
        >
          <MethodSelection
            onSelectMethod={(e: number) => onMethodSelection(e)}
            methods={methods}
            setOpen={setOpen}
            category={selectedCategory}
            categoryPreference={categoryPreference}
            categoryPreferences={categoryPreferences}
            setCategoryPreferences={setCategoryPreferences}
          />
        </Dialog>
      )}
      {!open && (
        <Fragment>
          {/* CATEGORYWISE */}
          {state.step === STEPS.CATEGORYWISE && (
            <div className="pw-scope-main w-55v overflow-y-auto">
              <div className="pw-input-label pw-create-label">
                {t("Select Scope")}
              </div>
              <div className="pw-bunit-create-desc pw-border-bottom">
                {t("Once selected cannot be edited in later stages")}
              </div>
              <div className="pw-scope-left-div flex flex-col ">
                <div>
                  <OutlinedInput
                    id="outlined-adornment-password "
                    className="pw-scope-search-field"
                    placeholder={t("Search")}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        {searchText === "" ? (
                          <IconButton onClick={onClickSearch} edge="end">
                            <SearchIcon />
                          </IconButton>
                        ) : (
                          <IconButton onClick={onClickCancel} edge="end">
                            <CloseIcon />
                          </IconButton>
                        )}
                      </InputAdornment>
                    }
                  />
                </div>
                {categoryData
                  .filter((each: any) => {
                    return searchText ? containsString(searchText, each) : true;
                  })
                  .map((each: any) => {
                    return (
                      <React.Fragment key={each.parent}>
                        <div className="pw-input-label pw-scope-title">
                          {each?.code + " - " + each?.name}
                        </div>
                        <div className="flex flex-row flex-wrap gap-6">
                          {each.categories
                            .filter((subCategory: any) =>
                              containsString(searchText, subCategory)
                            )
                            .map((element: any) => (
                              <div
                                className="pw-scope-card flex flex-col gap-6"
                                key={element.id}
                              >
                                <div className="pw-scope-category flex flex-row pw-border-bottom gap-4 items-center">
                                  <img
                                    src={
                                      imgURLs[
                                        element.code as keyof typeof imgURLs
                                      ]
                                    }
                                    className="mb-8"
                                  />

                                  <div className="pw-scope-card-title flex flex-col gap-2">
                                    <div className="pw-scope-category-name font-semibold text-sm">
                                      {element.name}
                                    </div>
                                    <div
                                      className={`pw-scope-category-no ${element.code?.replace(
                                        /[.\s]/g,
                                        ""
                                      )}`}
                                    >
                                      {element.code}
                                    </div>
                                  </div>
                                </div>
                                <div className="pw-scope-category-description text-sm">
                                  {element.description}
                                </div>
                                <div className="pw-proceed-button-wrapper">
                                  <div
                                    className={`pw-scope-button-proceed text-white bg-primary flex flex-row gap-1.5 items-center`}
                                    onClick={(e) => {
                                      onScopeSelect(element, each.scope);
                                    }}
                                  >
                                    <div className="text-xs text-semibold">
                                      {t("Proceed")}
                                    </div>
                                    <ArrowForwardIcon className="pw-proceed-icon" />
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </React.Fragment>
                    );
                  })}
                {/* <div className="pw-input-label pw-text">SCOPE 1</div>
          <div className="flex flex-row flex-wrap gap-6">
            {categoryData[0].categories.map((each) => (
              <div className="pw-scope-card flex flex-col">
                <div className="pw-scope-category flex flex-row pw-border-bottom gap-6 items-center">
                  <DirectionsCarIcon />
                  <div className="flex flex-col gap-1">
                    <div>{each.name}</div>
                    <div className="pw-scope-category-no">
                      {each.code}
                    </div>
                  </div>
                </div>
                <div className="pw-scope-category-description">
                  {each.description}
                </div>
              </div>
            ))}
          </div> */}
              </div>
            </div>
          )}

          {/* ASSETS */}

          {state.step === STEPS.ASSETS && (
            <AssetsScopeSelection
              assetsList={assetsList}
              setAssetsList={setAssetsList}
              setStep={setStep}
              setSelectedAssetsData={setSelectedAssetsData}
              handleMouseEnterProceed={handleMouseEnterProceed}
              handleMouseLeaveProceed={handleMouseLeaveProceed}
            />
          )}

          <div className="flex flex-row justify-end pw-scope-footer w-full gap-6">
            <div
              className="pw-scope-button-light pw-scope-button-cancel text-neutral bg-white font-bold"
              onClick={() => {
                navigate("/log/emissions", {
                  state: {
                    type: state.step,
                  },
                });
              }}
            >
              {t("Cancel")}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ScopeSelection;
